// Fuel 24 hydration calculator — tunable constants & product mapping.
// Tweak any coefficient here without touching app.js.

window.HYDRATION_CONFIG = {
  // ---- Brand ----
  // Pulled from drinkfuel24.com.
  brand: {
    primary: '#1F3A93',       // Fuel 24 blue
    primaryDark: '#152A6E',
    accent: '#FF7A1A',        // optional energy accent
  },

  // ---- Daily fluid baseline ----
  baselinePerKg: 35, // ml per kg of body weight (adult reference)

  ageModifiers: [
    { maxAge: 17, deltaPerKg: 5 },   // adolescents need more
    { maxAge: 65, deltaPerKg: 0 },   // adult reference
    { maxAge: 200, deltaPerKg: -5 }, // older adults
  ],

  // ---- Activity bonus (ml/day) ----
  activityBonus: { low: 0, medium: 300, high: 700 },

  // ---- Climate bonus (ml/day) ----
  climateBonus: { cold: -100, temperate: 0, hot: 500 },
  climateLabels: {
    cold: 'Cold Climate',
    temperate: 'Temperate Climate',
    hot: 'Hot Climate',
  },

  // ---- Life-stage bonus (female only, ml/day) ----
  lifeStageBonus: { none: 0, pregnant: 300, breastfeeding: 700 },

  // ---- Event bolus (ml/min by sport) ----
  eventMlPerMin: {
    none: 0,
    running: 18,
    cycling: 14,
    gym: 10,
    football: 16,
    five_a_side: 16,
    hiking: 9,
    hot_yoga: 15,
    swimming: 8,
    marathon: 22,
    custom: 12,
  },
  intensityMultiplier: { light: 0.7, moderate: 1.0, hard: 1.4 },

  // ---- Food + beverage modelling ----
  foodWaterFraction: 0.25,
  beverageWeights: {
    water: 1.00,
    coffee_tea_soft: 0.85,
    alcohol: 0.60,
    electrolyte_milk: 1.20,
  },
  glassSize: { water: 250, coffee_tea_soft: 125, alcohol: 125, electrolyte_milk: 250 },

  // ---- Unit conversions ----
  mlPerFlOz: 29.5735,
  kgPerLb: 0.453592,
  cmPerInch: 2.54,

  // ---- Sport options ----
  sportOptions: [
    { value: 'none', label: 'No specific event' },
    { value: 'running', label: 'Running' },
    { value: 'cycling', label: 'Cycling' },
    { value: 'gym', label: 'Gym / Weights' },
    { value: 'football', label: 'Football' },
    { value: 'five_a_side', label: '5-a-side' },
    { value: 'hiking', label: 'Hiking' },
    { value: 'hot_yoga', label: 'Hot Yoga' },
    { value: 'swimming', label: 'Swimming' },
    { value: 'marathon', label: 'Marathon / Long-distance' },
    { value: 'custom', label: 'Other (custom)' },
  ],

  // ---- Fuel 24 bottle line-up (drives the refill maths) ----
  // Pulled live from drinkfuel24.com.
  products: [
    {
      key: 'duo-700',
      name: 'The Duo Bottle',
      volumeMl: 700,
      volumeLabel: '700 ml',
      tagline: 'Insulated • 24h cold',
      image: 'https://www.drinkfuel24.com/cdn/shop/files/1000ML_View_05_01.jpg?v=1776957961&width=600',
      url: 'https://www.drinkfuel24.com/products/the-duo-bottle',
      price: '£13.49',
    },
    {
      key: 'duo-1000',
      name: 'The Duo Bottle',
      volumeMl: 1000,
      volumeLabel: '1 L',
      tagline: 'Insulated • 24h cold',
      image: 'https://www.drinkfuel24.com/cdn/shop/files/1000ML_View_05_01.jpg?v=1776957961&width=600',
      url: 'https://www.drinkfuel24.com/products/the-duo-bottle',
      price: '£17.99',
    },
    {
      key: 'original-jug',
      name: 'The Original Jug',
      volumeMl: 2200,
      volumeLabel: '2.2 L',
      tagline: 'BPA-free • daily target',
      image: 'https://www.drinkfuel24.com/cdn/shop/products/oldCapTransparantBlack_01.jpg?v=1652465334&width=600',
      url: 'https://www.drinkfuel24.com/products/original-jug',
      price: '£15.99',
    },
    {
      key: 'steel-jug',
      name: 'The Steel Jug',
      volumeMl: 2200,
      volumeLabel: '2.2 L',
      tagline: 'Stainless • leak-proof',
      image: 'https://www.drinkfuel24.com/cdn/shop/products/2.2stealth_02.jpg?v=1650647665&width=600',
      url: 'https://www.drinkfuel24.com/products/steel-jug',
      price: '£21.59',
    },
  ],

  // ---- Electrolytes hero (top of results, pushed first per client brief) ----
  electrolytesTagline: {
    heading: 'STAY SHARP. STAY HYDRATED.',
    sub: 'Electrolytes and bottles that keep you moving.',
  },
  electrolytesPitch:
    'Sodium is what lets your body hold onto the water you drink. ' +
    'Without it, much of it passes straight through. ' +
    'Replace what you lose first, then top up with water.',
  // Recommendation copy in the electrolytes hero. [n] = servings count placeholder.
  recommendation: {
    zeroHeading: 'Worth keeping handy',
    zeroSub: 'Useful on hot days, after workouts or when you feel run-down.',
    servingsSingleHeading: '1 serving recommended today',
    servingsMultiHeading: '[n] servings recommended today',
    servingsSub: 'Based on your activity, climate and event.',
  },
  electrolyteProduct: {
    name: 'Fuel 24 Electrolytes',
    tagline: 'Coconut water + vitamins · 500 mg sodium per serving',
    image: 'https://www.drinkfuel24.com/cdn/shop/files/Lemon_Lime.jpg?v=1773061568&width=600',
    url: 'https://www.drinkfuel24.com/products/electrolyte',
    price: '£9.99',
  },
  // Daily servings recommendation logic (mirrors invigorate.fit).
  // Tweak the thresholds here without touching app.js.
  electrolyteServings: function (s) {
    let n = 0;
    if (s.climate === 'hot') n += 1;
    if (s.activity === 'high') n += 1;
    if (s.eventEnabled && s.event && s.event.durationMin) {
      if (s.event.durationMin >= 60) n += 1;
      if (s.event.durationMin >= 120) n += 1;
      if (s.event.intensity === 'hard') n += 1;
    }
    return Math.min(n, 6);
  },

  // ---- Bundle upsell (appears below bottles) ----
  bundle: {
    name: 'Build Your Starter Bundle',
    tagline: 'Bottle + electrolytes. Save on the combo.',
    image: 'https://www.drinkfuel24.com/cdn/shop/files/Lifestyle-Landscape15_a90a97b3-0afb-409d-a6ec-93f2638f3759.jpg?v=1777151278&width=600',
    url: 'https://www.drinkfuel24.com/pages/bundle',
    price: 'Bundle & save',
  },

  // ---- Methodology sources (shown at bottom of the methodology modal) ----
  methodologySources: [
    { label: 'EFSA Scientific Opinion on Dietary Reference Values for Water (2010)', url: 'https://www.efsa.europa.eu/en/efsajournal/pub/1459' },
    { label: 'IOM Dietary Reference Intakes for Water, Potassium, Sodium, Chloride and Sulfate (2004)', url: 'https://nap.nationalacademies.org/catalog/10925/' },
    { label: 'ACSM Position Stand on Exercise and Fluid Replacement (2007)', url: 'https://journals.lww.com/acsm-msse/Fulltext/2007/02000/Exercise_and_Fluid_Replacement.22.aspx' },
    { label: 'NHS UK — Water, drinks and your health', url: 'https://www.nhs.uk/live-well/eat-well/food-guidelines-and-food-labels/water-drinks-nutrition/' },
  ],

  shopAllUrl: 'https://www.drinkfuel24.com/collections/all',
};
